<template>
  <div
    class=" mt-3 feedback-block animate__animated animate__slideInDown"
    v-if="customer && customer.id && !dismiss"
  >
    <div v-if="!feedback_sent">
      <div>How are we doing today?</div>
      <div class="details-container d-flex justify-content-center my-3">
        <div
          @click="selectRating(1)"
          class="r-icon"
          :class="{'selected':selectedRating==1}"
        ><i class="far fa-smile-beam mr-1 "></i></div>
        <div
          @click="selectRating(2)"
          class="r-icon"
          :class="{'selected':selectedRating==2}"
        ><i class="far fa-smile  mr-1"></i></div>
        <div
          @click="selectRating(3)"
          class="r-icon"
          :class="{'selected':selectedRating==3}"
        ><i class="far fa-meh mr-1"></i></div>
        <div
          @click="selectRating(4)"
          class="r-icon"
          :class="{'selected':selectedRating==4}"
        ><i class="far fa-frown "></i></div>
      </div>
      <div
        class="animate__animated animate__fadeIn"
        v-if="selectedRating"
      >
        <div class="form-group d-flex flex-column justify-content-center ">
          <div class="tiny-text text-white mb-2"> Help us improve. Please tell us more (optional)</div>
          <input
            v-model="formText"
            class="form-control feedback-text"
            maxlength="256"
          />
        </div>
        <button
          v-if="selectedRating && !processing && !sending"
          class="btn btn-block btn-lg mt-3"
          @click="sendFeedback()"
        >Send</button>
        <div
          v-if="selectedRating && !processing && sending"
          class="btn btn-block btn-lg mt-3"
        >Sending...</div>
      </div>
      <a
        class="text-center small mt-2"
        @click="dismissFeedback()"
      >Dismiss</a>
    </div>
    <div v-else>
      <div class="h3">Thank you</div>
      <p>Your feedback helps us make your experience at {{ menu.user.name }} better.</p>
      <button
        class="btn btn-block btn-lg mt-3"
        @click="dismissFeedback()"
      >Close</button>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.feedback-block {
  position: fixed;
  top: 0;
  text-align: center;
  font-weight: 400;
  color: #fff;
  padding: 1rem;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  cursor: pointer;
  border-radius: 0.5rem;

  width: 90%;
  margin: 5%;
  z-index: 10000;
}
.btn {
  background-color: #fff;
  border-color: #fff;
  color: var(--user-highlight-color);
  max-width: 300px;
  margin: auto;
}
.details-container {
  font-size: 3.5rem;
  cursor: pointer;
  .r-icon {
    display: inline-flex;
    opacity: 0.5;
    &.selected {
      opacity: 1;
    }
  }
}
.feedback-text {
  background-color: #eee;
  border-color: #eee;
  color: #000;
  max-width: 300px;
  margin: auto;
}
</style>

<script>
import cartMixin from "../../mixins/cartMixin";
export default {
  mounted() {
    this.getCustomer();
  },
  data() {
    return {
      sent: false,
      selectedRating: 0,
      showForm: false,
      formText: null,
      customer: null,
      dismiss: false,
      processing: false,
      sending: false,
      feedback_sent: false,
    };
  },
  methods: {
    sendFeedback: function () {
      this.sending = true;
      axios
        .post("/api/customer/submit-feedback", {
          rating: this.selectedRating,
          feedback_text: this.formText,
          customer_id: this.customer.id,
          user_id: this.menu.user.id,
        })
        .then(
          (response) => {
            this.sending = false;
            this.feedback_sent = true;
          },
          (error) => {
            this.processing = false;
          }
        );
    },
    dismissFeedback: function () {
      this.processing = true;
      axios.post("/api/customer/dismiss-feedback", {}).then(
        (response) => {
          this.processing = true;
          this.getCart();
        },
        (error) => {
          this.processing = true;
        }
      );
    },
    getCustomer() {
      this.processing = true;
      axios
        .post("/api/customer/get-by-email", {
          email: this.cart.receipt_email,
          user_id: this.menu.user.id,
        })
        .then(
          (response) => {
            this.processing = false;
            if (response.data.id) {
              this.customer = response.data;
            }
          },
          (error) => {
            this.processing = false;
          }
        );
    },
    selectRating: function (rating) {
      this.selectedRating = rating;
    },
  },
  mixins: [cartMixin],
  props: {
    menu: {
      type: Object,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
};
</script>
